var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bawpkql9ka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.333333 0 0 0 0 0.368627 0 0 0 0 0.384314 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "1ko8fy18vb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.050980 0 0 0 0 0.098039 0 0 0 0 0.121569 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#bawpkql9ka)",
    transform: "translate(-1205 -119)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#1ko8fy18vb)",
    transform: "translate(1205 118)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 0.5L3.2 11.5",
    transform: "translate(0 1) matrix(1 0 0 -1 8.8 16)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M0 3.209L3.209 0 6.419 3.209",
    transform: "translate(0 1) matrix(1 0 0 -1 8.8 16)"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M4 15L4 20 20 20 20 15",
    transform: "translate(0 1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.49b382e4db6b7c22aab05dfc2acfcad1.svg";
export { ForwardRef as ReactComponent };